import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MaterialModule } from '../../../@fury/shared/material-components.module';
import { DashboardRoutingModule } from './dashboard-routing.module';
import { DashboardComponent } from './dashboard.component';
import { FurySharedModule } from '../../../@fury/fury-shared.module';
import {MatTabsModule} from '@angular/material/tabs';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatFormFieldModule} from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {DateAdapter, MatNativeDateModule} from '@angular/material/core';
import {MatInputModule} from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';

@NgModule({
  imports: [
    CommonModule,
    DashboardRoutingModule,
    MaterialModule,
    FurySharedModule,
    MatTabsModule,
    MatDatepickerModule,
    MatFormFieldModule,
    FormsModule, 
    ReactiveFormsModule,
    MatNativeDateModule,
    MatInputModule,
    MatSelectModule
  ],
  declarations: [DashboardComponent],
  providers: []
})
export class DashboardModule {
}
